import { filter, mergeMap, of, withLatestFrom } from 'rxjs'
import { catchError, retryWhen } from 'rxjs/operators'
import { authenticationExpiredOr } from '../../../../Framework/Epic/AuthenticationExpired.js'
import { serverIsNotAvailable } from '../../../../Framework/Epic/ServerNotAvailable.js'
import type { Epic } from '../../../index.js'
import { Actions } from '../../../Slice/index.js'

export const GetDatasetReportEpic: Epic = (action$, state$, { order, OrderRepository }) =>
  action$.pipe(
    filter(Actions.order.getDatasetReportRequest.match),
    withLatestFrom(state$),
    mergeMap(([action, state]) =>
      OrderRepository.getDatasetReport(action.payload, state.authentication.user).pipe(
        mergeMap((response) => {
          const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const blobUrl = URL.createObjectURL(blob)
          const downloadLink = document.createElement('a')
          downloadLink.href = blobUrl
          downloadLink.download = 'redlist_reordered_raw_GBIF_otus_fasta.xlsx'
          document.body.appendChild(downloadLink)
          downloadLink.click()
          URL.revokeObjectURL(blobUrl)
          document.body.removeChild(downloadLink)
          return of(order.getDatasetReportSuccess(response))
        }),
        retryWhen(serverIsNotAvailable()),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.getDatasetReportFailure({ error }))
          })
        )
      )
    )
  )
